module.exports = __webpack_public_path__ + "h5/img/offer_2023.40af589e.png";